import { render, staticRenderFns } from "./UserCompanyAdd.vue?vue&type=template&id=2ab99316&"
import script from "./UserCompanyAdd.vue?vue&type=script&lang=js&"
export * from "./UserCompanyAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports